import {
  Box, Flex, Icon, Stack, Text, useColorModeValue, useToast,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import {HSeparator} from "components/Separator/Separator";
import React, {useEffect, useRef, useState} from "react";
import {FiClock, FiMic, FiUser} from "react-icons/fi";
import {updateConversation} from "../../../../api/lawdiskService";

const Transcript = ({
                      completedConversation,
                      conceptSentence,
                      conversation,
                      isStopped,
                    }) => {
  const scrollRef = useRef(null);

  const toast = useToast();

  const textColor = useColorModeValue("gray.700", "white");
  const [groupedCompletedConversation, setGroupedCompletedConversation] = useState([]);
  const [rawConversation, setRawConversation] = useState("");
  const [conversationLoaded, setConversationLoaded] = useState(false);

  function formatTimeWithMilliseconds(ms) {
    const date = new Date(ms);
    const pad = (n, len = 2) => n.toString().padStart(len, '0');

    return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${pad(date.getMilliseconds(), 3)}`;
  }

  function groupConversationsByWordCount(conversations, minWords = 150) {
    const result = [];
    let currentGroup = {
      sentence: '', timestamp: null, timestampLast: null, wordCount: 0
    };

    if (conversationLoaded && conversation.text !== "" && conversation.text !== null && conversation?.text !== ""){
      result.push({
        completed: true, conversation: {
          sentence: conversation.text,
          timestamp: conversation.createdAt,
          timestampLast: conversation.createdAt,
        }
      });
    }

    for (let i = 0; i < conversations.length; i++) {
      const item = conversations[i];
      const {sentence, words, timestamp} = item.conversation;
      const wordCount = sentence.trim().split(/\s+/).length;

      if (currentGroup.wordCount === 0) {
        currentGroup.timestamp = timestamp;
      }

      currentGroup.sentence += (currentGroup.sentence ? ' ' : '') + sentence;
      currentGroup.timestampLast = timestamp;
      currentGroup.wordCount += wordCount;

      if (currentGroup.wordCount >= minWords) {
        result.push({
          completed: true, conversation: {
            sentence: currentGroup.sentence,
            timestamp: currentGroup.timestamp,
            timestampLast: currentGroup.timestampLast
          }
        });

        currentGroup = {
          sentence: '', timestamp: null, timestampLast: null, wordCount: 0
        };
      }
    }

    if (currentGroup.wordCount > 0) {
      result.push({
        completed: false, conversation: {
          sentence: currentGroup.sentence, timestamp: currentGroup.timestamp, timestampLast: currentGroup.timestampLast
        }
      });
    }

    setGroupedCompletedConversation(result);
  }

  useEffect(() => {
    if (conversation !== undefined) {
      setConversationLoaded(true);

    }
  }, [conversation])

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
    if (completedConversation.length > 0) {
      // Raw text for current API
      setRawConversation((prev) => prev.trim().concat(` ${completedConversation.at(-1)?.conversation?.sentence}`));
      groupConversationsByWordCount(completedConversation);
    }
    if (conversationLoaded && conversation.text !== "" && conversation.text !== null && rawConversation === ""){
      groupConversationsByWordCount([]);
      setRawConversation(conversation.text);
    }
  }, [completedConversation, conversationLoaded]);

  useEffect(() => {
    const UpdateConversationV1 = async () => {
      if (rawConversation !== "" && conversationLoaded === true) {
        try {
          const response = await updateConversation(conversation.id, rawConversation, null);
        } catch (error) {
          if (error.message === "Premium verlopen") {
            toast({
              title: "Premium verlopen",
              description:
                "U bent door uw gratis minuten heen en bent hierdoor niet meer in de gelegenheid te transcriberen. Uw notule is (deels) opgeslagen.",
              status: "error",
              duration: null,
              isClosable: true,
            });
          }
        }
      }
    };

    UpdateConversationV1();

  }, [rawConversation])

  useEffect(() => {
    const EndConversationV1 = async () => {
      if (rawConversation !== "" && conversationLoaded === true && conceptSentence?.conversation?.sentence !== undefined) {
        setRawConversation((prev) => prev.trim().concat(` ${conceptSentence?.conversation?.sentence}`));
        try {
          const response = await updateConversation(conversation.id, rawConversation, null);
        } catch (error) {
          if (error.message === "Premium verlopen") {
            toast({
              title: "Premium verlopen",
              description:
                "U bent door uw gratis minuten heen en bent hierdoor niet meer in de gelegenheid te transcriberen. Uw notule is (deels) opgeslagen.",
              status: "error",
              duration: null,
              isClosable: true,
            });
          }
        }
      }
    }

    EndConversationV1()

  }, [isStopped])

  return (<Card p={{sm: "16px", md: "22px"}} maxW={{sm: "330px", md: "100%"}}>
    <CardHeader pb={'30px'}>
      <Flex justify="space-between" w="100%">
        <Text color={textColor} fontSize="lg" fontWeight="bold">
          Transcriptie
        </Text>
      </Flex>
    </CardHeader>
    <CardBody>
      <Flex
        ref={scrollRef}
        direction="column"
        w="100%"
        maxH={'500px'}
        overflowX={{sm: "scroll", md: "hidden"}}
        overflowY={'auto'}
      >
        <HSeparator my="14px"/>
        {groupedCompletedConversation.filter(group => group.completed === true).map((conversation, index) => (<>
          <Flex>
            <Flex
              bgColor="var(--primary-color)"
              borderRadius="12px"
              minWidth="3px"
              h="100%"
            />
            <Flex direction="column" p="12px 22px" w="100%" w="100%">
              <Flex justify="space-between" mb="18px">
                <Flex align="center">
                  <Text color={textColor} fontSize="sm" fontWeight="bold">
                    {conversation?.conversation?.sentence}
                  </Text>
                </Flex>
              </Flex>
              <Stack
                direction="row"
                spacing={{
                  sm: "20px", md: "40px", lg: "40px", xl: "40px",
                }}
                ms={{sm: "0px", md: "36px", lg: "0px", xl: "36px"}}
              >
                <Flex direction="column">
                  <Flex direction="row" align="center">
                    <FiClock/>
                    {" "}
                    <Text color="gray.700" fontWeight="normal" fontSize="sm">
                      Van
                    </Text>
                  </Flex>
                  <Text color="gray.500" fontWeight="bold" fontSize="xs">
                    {formatTimeWithMilliseconds(conversation?.conversation.timestamp)}
                  </Text>
                </Flex>
                <Flex direction="column">
                  <Flex direction="row" align="center">
                    <FiClock/>
                    {" "}
                    <Text color="gray.700" fontWeight="normal" fontSize="sm">
                      Tot
                    </Text>
                  </Flex>
                  <Text color="gray.500" fontWeight="bold" fontSize="xs">
                    {formatTimeWithMilliseconds(conversation?.conversation.timestampLast)}
                  </Text>
                </Flex>
                <Flex direction="column">
                  <Flex direction="row" align="center">
                    <FiUser/>
                    {" "}
                    <Text color="gray.700" fontWeight="normal" fontSize="sm">
                      Spreker(s)
                    </Text>
                  </Flex>
                  <Text color="gray.500" fontWeight="bold" fontSize="xs">
                    Onbekend
                  </Text>
                </Flex>
              </Stack>
            </Flex>
          </Flex>
          <HSeparator my="8px"/>
        </>))}


        <Flex>
          <Flex
            bgColor="red.200"
            borderRadius="12px"
            minWidth="3px"
            h="100%"
          />{" "}
          <Flex direction="column" p="12px 22px" w="100%">
            <Flex justify="space-between" mb="18px">
              <Flex align="center">
                <FiMic/>
                <Text color={textColor} fontSize="sm" fontWeight="bold">
                  Live tekst:
                </Text>
              </Flex>
            </Flex>
            <Flex justify="space-between" mb="18px">
              <Text color={textColor} fontSize="sm" fontWeight="thin" fontStyle={"italic"}>
                {groupedCompletedConversation?.find(group => group.completed === false)?.conversation?.sentence ?? ""}
                {conceptSentence?.conversation?.sentence}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </CardBody>
  </Card>);
};

export default Transcript;
